import { render, staticRenderFns } from "./AcceptTerms.vue?vue&type=template&id=530e3f82&scoped=true&"
import script from "./AcceptTerms.vue?vue&type=script&lang=js&"
export * from "./AcceptTerms.vue?vue&type=script&lang=js&"
import style0 from "./AcceptTerms.vue?vue&type=style&index=0&id=530e3f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530e3f82",
  null
  
)

export default component.exports